<div class="wrapper">
  <div id="brChart" [ngClass]="{'special': (showPlaceholder$ | async)}" #brChart></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>BR graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
    </div>
  }
</div>